import { format } from 'date-fns';
import { AddToCalender } from '../../../Components/AddToCalender';
import { FuneralService, FuneralServiceEvent } from '../../../types';

const Event = ({ event, service }: { event: FuneralServiceEvent; service: FuneralService }) => {
  const { address } = event.venue;
  const link = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <div className="event-container-2">
      <strong>{event.name} </strong>
      <div className="event-date">{!event.is_date_hidden && format(new Date(event?.start_at), "EEEE do MMMM y 'at' h:mm a")}</div>
      <div className="event-details-container">
        <div>
          {!event.is_venue_hidden && (
            <a href={link} target="_blank" className="text-accent-color">
              <div className="event-venue-container">
                <div className="event-venue-name">{event?.venue.name}</div>
                <span className="event-address">{event?.venue.address}</span>
              </div>
            </a>
          )}
        </div>
      </div>
      <AddToCalender text={true} event={event} service={service} />
    </div>
  );
};

const ServiceEvents2 = ({ events, service }: { events: FuneralServiceEvent[] | null | undefined; service: FuneralService }) => (
  <div className="events-container"> {events?.map((event) => <Event key={event.hash} event={event} service={service} />)}</div>
);

export default ServiceEvents2;
